import {ComponentLink}  from "@Common/react/cst2";
import {Types}          from "@Common/types";
import {ModalService3}  from "@Common/ui-components/modal-service-3/modal-service-3";

import {MailedStatusContent}  from "./mailed-status";
import {ShippedStatusContent} from "./shipped-status";

type Item = Types.Apis.Payloads.Next.Item.GetHistory.Item;

export const DeliveryStatus = ({next: rootNext}:{
    next : ComponentLink<typeof ModalService3<{item: Item}>, "rootNext">,
}) => (
    ModalService3({
        xdQaName: "Delivery Status Modal",
        width: 1100,
        next: ({params: {item}}) => (
            item.deliveryStatus === 'Shipped' ? (
                ShippedStatusContent({item,})
            ) : (
                MailedStatusContent({itemId: item.itemId,})
            )
        ),
        xToClose: true,
        rootNext,
    })
);

